import { render } from "./PersonalDataPolicy.vue?vue&type=template&id=7aaec0e8"
import script from "./PersonalDataPolicy.vue?vue&type=script&lang=js"
export * from "./PersonalDataPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__